import { Component, OnInit, Renderer2 } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { timer } from "rxjs";
import { take } from "rxjs/operators";
import { ConfiguracionOpcionesModalInput } from "./ConfiguracionOpcionesModalInput";

@Component({
    selector: "app-modal-input",
    templateUrl: "./modal-input.component.html",
    styleUrls: ["./modal-input.component.scss"]
})
export class ModalInputComponent<T> implements OnInit {

    public mensaje = "";
    public inputValor = "";

    public inputValorNumero = 0;
    public esNumero = false;

    public esOpciones = false;
    public configuracionOpciones: ConfiguracionOpcionesModalInput<T>;
    public item: any;

    constructor(private activeModal: NgbActiveModal, private renderer2: Renderer2) { }

    ngOnInit(): void {
        timer(200).pipe(take(1)).subscribe(() => {
            if (this.esOpciones) {
                return;
            }

            let onElement: any;
            if (this.esNumero) {
                onElement = this.renderer2.selectRootElement("#inputNumber");
            } else {
                onElement = this.renderer2.selectRootElement("#inputText");
            }
            onElement.focus();
        });
    }

    public cerrar(): void {
        this.activeModal.dismiss();
    }

    public enviar(): void {
        let valorDevolver: any = this.inputValor;

        if (this.esNumero) {
            valorDevolver = this.inputValorNumero;
        }

        if (this.esOpciones) {
            valorDevolver = this.item;
        }

        this.activeModal.close(valorDevolver);
    }
}
